<div *ngIf="frame && frame[field] !== undefined" class="indicator-container">
	<div class="heading">{{ label }}</div>
	<div class="value">
		<span>{{ frame[field] | number:'1.2-2' }}</span>
		<span class="units">{{ units }}</span>
	</div>
</div>